export default __webpack_public_path__ + "static/media/avatar.b41ef275.svg";